import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationOntologyForAutomaticProtocolCreateRequest,
    ConfigurationOntologyForAutomaticProtocolPatchRequest,
    ConfigurationOntologyForAutomaticProtocolResponse
} from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationOntologyForAutomaticProtocolService {
    async create(laboratoryId: number, request: ConfigurationOntologyForAutomaticProtocolCreateRequest): Promise<ConfigurationOntologyForAutomaticProtocolResponse> {
        const response = await axios.post<ConfigurationOntologyForAutomaticProtocolResponse>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticProtocols`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationOntologyForAutomaticProtocolResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationOntologyForAutomaticProtocolResponse>>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticProtocols`, { ...filterModel }, { params })
        return response.data
    }

    async get(laboratoryId: number, ontologyForAutomaticProtocolId: number): Promise<ConfigurationOntologyForAutomaticProtocolResponse[]> {
        const response = await axios.get<ConfigurationOntologyForAutomaticProtocolResponse[]>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticProtocols/${ontologyForAutomaticProtocolId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticProtocols/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, ontologyForAutomaticProtocolId: number, request: ConfigurationOntologyForAutomaticProtocolPatchRequest): Promise<ConfigurationOntologyForAutomaticProtocolResponse> {
        const response = await axios.patch<ConfigurationOntologyForAutomaticProtocolResponse>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticProtocols/${ontologyForAutomaticProtocolId}`, request)
        return response.data
    }
}

export const configurationOntologyForAutomaticProtocolService = new ConfigurationOntologyForAutomaticProtocolService()
